export default defineNuxtPlugin({
	name: "components",
	order: 1050,
	setup: (nuxtApp) => {
		const { $componentsManager } = nuxtApp.vueApp.config.globalProperties;

		$componentsManager.addSettings({
			components: {
				/**
				 * IMAGES
				 */
				BanzaImg: {
					presets: {
						AccessDenied: {
							attrs: {
								src: "/img/access_denied.svg",
							},
						},
					},
				},
			},
		});
	},
});
